import { render, staticRenderFns } from "./SecurityCameraIcon.vue?vue&type=template&id=28872d01"
import script from "./SecurityCameraIcon.vue?vue&type=script&lang=js"
export * from "./SecurityCameraIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports